import { useAppSelector } from "#store";
import { selectOperatorInvocationRawById } from "#selectors";
import { LinearProgress } from "@mui/material";
import React from "react";
import { Caption, P } from "#/components/Common/headings";
import { OperatorStatus } from "#services/pilotService/types";

export const OperatorInvocationProgress = ({ id }: { id: number }) => {
    const operatorIoState = useAppSelector(state =>
        selectOperatorInvocationRawById(state, id)
    );
    if (!operatorIoState) {
        return null;
    } else {
        const state = operatorIoState.state;
        const heading = `Operator ${id}`;

        switch (state) {
            case "fetching":
                return (
                    <P>
                        <>{heading}</>
                        <LinearProgress variant={"indeterminate"} />
                    </P>
                );
            case "done":
                // const caption = !operatorIoState.payload.finished ? null : `(${operatorIoState.payload.interpretations.length}/${operatorIoState.payload.rawInterpretationCount})`;
                if (operatorIoState.payload?.status === OperatorStatus.FAILED) {
                    return <>{heading} (failed)</>;
                }
                const p_done =
                    100 *
                    (operatorIoState.payload.interpretations.length /
                        operatorIoState.payload.rawInterpretationCount);
                const progress = (
                    <>
                        {" "}
                        ({operatorIoState.payload.interpretations.length}/
                        {operatorIoState.payload.rawInterpretationCount})
                        <LinearProgress
                            variant={"determinate"}
                            value={p_done}
                        />
                    </>
                );
                return (
                    <>
                        {heading}
                        {/*{caption}*/}
                        {progress}
                    </>
                );
            case "error":
            default:
                return (
                    <>
                        {heading}
                        <Caption>error</Caption>
                    </>
                );
        }
    }
};
